import React from 'react'
import { Modal } from '@web/walter-ui-kit'
import { GetProducts } from '@web/walter-lib/api'
import Content from './Content'

interface Props {
    isOpen: boolean
    onClose: () => void
    product?: GetProducts
}

function IssuesModal({ isOpen, onClose, product }: Props) {
    return (
        <Modal
            withHeaderBorder={false}
            type="dialog"
            onClose={onClose}
            isOpen={isOpen}
            dataPointer="issues_modal"
            size="xs"
        >
            <Content onClose={onClose} product={product} />
        </Modal>
    )
}

export default IssuesModal
